import { render } from "./ItemVideo.vue?vue&type=template&id=196428fc&scoped=true&ts=true"
import script from "./ItemVideo.vue?vue&type=script&lang=ts"
export * from "./ItemVideo.vue?vue&type=script&lang=ts"

import "./ItemVideo.vue?vue&type=style&index=0&id=196428fc&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196428fc"]])

export default __exports__